'use strict';

function isTreeHealthy(node) {
  if (node === null || node === false) {
    //console.log('Node is null or false.', node);
    return true;
  } else if (typeof node === 'string') {
    //console.log('Node is a string.', node);
    return node.length > 0 ? false : true;
  } else if (node.constructor === Array) {
    //console.log('Node is an Array.', node);
    for (let i = 0; i < node.length; i++) {
      if (!isTreeHealthy(node[i])) {
        return false;
      }
    }
    return true;
  } else if (typeof node === 'object') {
    //console.log('Node is an object.', node);
    const keys = Object.keys(node);
    for (let i = 0; i < keys.length; i++) {
      if (!isTreeHealthy(node[keys[i]])) {
        return false;
      }
    }
    return true;
  } else {
    console.log('Node is of an unknown type.', node);
    throw new Error('Node is of an unknown type.');
  }
}

// Collect every human-readable error message from a validation tree. Mirrors
// the traversal in `isTreeHealthy`, but instead of a boolean it returns the
// non-empty string leaves so callers can surface exactly which fields failed.
function collectTreeErrors(node: unknown): string[] {
  if (typeof node === 'string') {
    return node.length > 0 ? [node] : [];
  } else if (Array.isArray(node)) {
    return node.flatMap(collectTreeErrors);
  } else if (node !== null && typeof node === 'object') {
    return Object.values(node).flatMap(collectTreeErrors);
  } else {
    return [];
  }
}

export { isTreeHealthy, collectTreeErrors };
